// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iv_a bhc_rm","PhotoTitleEditForm__cancelBtn":"iv_b bhc_rq bhc_rp"};